<template>
  <v-menu
    v-model="isShow"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    class="datePicker"
    :content-class="
      $attrs['hide-details'] === '' || $attrs['hide-details'] === true
        ? 'datePicker'
        : 'datePicker mt-n6'
    "
  >
    <template v-slot:activator="{ on, attrs }">
      <div :style="width && `width: ${width}`" :class="classInput">
        <v-text-field
          :class="{ requiredLabel: required }"
          v-model="selected"
          @input="$emit('input', $event)"
          append-icon="mdi-calendar"
          @click="openDialog"
          @click:append="openDialog"
          outlined
          :label="label"
          :clearable="clearable"
          dense
          v-bind="{ ...$attrs, ...attrs }"
          readonly
          v-on="readonly ? null : on"
          :hide-details="hideDetails"
          :error-messages="errorMessage"
        />
      </div>
    </template>
    <v-date-picker
      scrollable
      locale="ja"
      no-title
      v-model="selected"
      @input="isShow = false"
      :show-week="showWeek"
      :min="min"
      :max="max"
    />
  </v-menu>
</template>

<script>
export default {
  components: {},
  inheritAttrs: false,
  props: {
    value: {},
    label: {
      type: String,
      required: false,
    },
    width: {
      type: String,
    },
    hideDetails: {
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    errorMessage: {
      type: String,
    },
    showWeek: {
      type: Boolean,
      default: false,
    },
    min: {},
    max: {},
    required: {
      type: Boolean,
      default: false,
    },
    classInput: {
      type: String,
      default: "",
    },
  },
  name: "DatePicker",
  data: () => ({
    isShow: false,
  }),
  methods: {
    openDialog() {
      if (!this.readonly) this.isShow = true;
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss">
.datePicker.v-menu__content.theme--light.menuable__content__active {
  min-width: 0 !important;
}

.requiredLabel label {
  &:after {
    font-weight: bold;
    content: " *";
    color: #ff5252;
    font-size: 17px;
  }
}
</style>
